var map = {
	"./bady_bg_shadow.png": 5834,
	"./bady_bg_shadow_test.png": 7906,
	"./bg_dot.png": 3410,
	"./bg_line.png": 880,
	"./bg_line_2.png": 7452,
	"./def.png": 4067,
	"./header_bar.png": 932,
	"./i_banner_shadow.png": 3538,
	"./i_banner_shadow_.png": 8794,
	"./i_brand_left.png": 9378,
	"./i_brand_right.png": 5894,
	"./i_download_1.png": 9520,
	"./i_download_2.png": 1880,
	"./i_news_bg.png": 9327,
	"./i_video_icon.png": 1410,
	"./icon_media_1.png": 571,
	"./icon_media_10.png": 8831,
	"./icon_media_11.png": 5841,
	"./icon_media_2.png": 7188,
	"./icon_media_3.png": 2297,
	"./icon_media_4.png": 1407,
	"./icon_media_5.png": 6914,
	"./icon_media_5__.png": 4185,
	"./icon_media_6.png": 9088,
	"./icon_media_7.png": 4706,
	"./icon_media_8.png": 8821,
	"./icon_media_9.png": 4404,
	"./icon_premium_1.png": 175,
	"./icon_premium_1_.png": 9779,
	"./icon_sponsors_1.png": 8890,
	"./icon_sponsors_10.png": 1946,
	"./icon_sponsors_11.png": 5706,
	"./icon_sponsors_12.png": 4836,
	"./icon_sponsors_13.png": 2489,
	"./icon_sponsors_14.png": 5970,
	"./icon_sponsors_15.png": 1802,
	"./icon_sponsors_16.png": 5480,
	"./icon_sponsors_17.png": 2811,
	"./icon_sponsors_18.png": 8232,
	"./icon_sponsors_19.png": 2266,
	"./icon_sponsors_2.png": 3909,
	"./icon_sponsors_20.png": 6480,
	"./icon_sponsors_21.png": 5287,
	"./icon_sponsors_22.png": 2167,
	"./icon_sponsors_23.png": 5558,
	"./icon_sponsors_24.png": 1352,
	"./icon_sponsors_25.png": 1156,
	"./icon_sponsors_26.png": 1978,
	"./icon_sponsors_27.png": 3028,
	"./icon_sponsors_28.png": 471,
	"./icon_sponsors_29.png": 1371,
	"./icon_sponsors_3.png": 1297,
	"./icon_sponsors_30.png": 7094,
	"./icon_sponsors_31.png": 8933,
	"./icon_sponsors_32.png": 4385,
	"./icon_sponsors_32_.png": 1413,
	"./icon_sponsors_33.png": 9202,
	"./icon_sponsors_34.png": 8799,
	"./icon_sponsors_35.png": 5933,
	"./icon_sponsors_35_.png": 2087,
	"./icon_sponsors_36.png": 9316,
	"./icon_sponsors_37.png": 5205,
	"./icon_sponsors_38.png": 1487,
	"./icon_sponsors_39.png": 7650,
	"./icon_sponsors_4.png": 3301,
	"./icon_sponsors_40.png": 3260,
	"./icon_sponsors_5.png": 3671,
	"./icon_sponsors_6.png": 6926,
	"./icon_sponsors_7.png": 507,
	"./icon_sponsors_8.png": 4627,
	"./icon_sponsors_9.png": 9635,
	"./judge_bg.png": 145,
	"./line_black.png": 2055,
	"./logo.png": 4427,
	"./logo_bg.png": 5695,
	"./logo_bg_.png": 1598,
	"./logo_tt.png": 4914,
	"./main_tab_grey.png": 33,
	"./main_tab_grey_hover.png": 5242,
	"./main_tab_hover.png": 4710,
	"./main_tab_line.png": 7754,
	"./menulogo_01.png": 4211,
	"./menulogo_mobile.png": 9723,
	"./modder_light_line.png": 3455,
	"./modder_top_ti_in.png": 9811,
	"./modder_work_log_shadow.png": 6960,
	"./page_aw.png": 1395,
	"./pic_ai_voice.png": 5473,
	"./pic_rgb_ai.png": 2513,
	"./pic_rgb_neon.png": 3198,
	"./pic_rgb_plus_eco.png": 177,
	"./pic_rules_1.png": 1736,
	"./pic_rules_2.png": 1701,
	"./pic_rules_3.png": 6870,
	"./pic_rules_4.png": 5039,
	"./prize_icon_1.png": 4494,
	"./prize_reward_1.png": 5153,
	"./prize_reward_2.png": 6856,
	"./prize_reward_3.png": 8078,
	"./spon_pro_1.png": 2039,
	"./spon_pro_2.png": 1248,
	"./spon_pro_3.png": 7795,
	"./spon_pro_4.png": 4539,
	"./tabs_bg.png": 9372,
	"./ti_bar.png": 7832,
	"./vote_bar.png": 6591,
	"./vote_step_1.png": 2466,
	"./vote_step_2.png": 2722,
	"./vote_step_3.png": 754,
	"./vote_top_bg.png": 6322,
	"./website_close.png": 2424,
	"./winner_bg.png": 6598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;